module.exports = __webpack_public_path__ + "static/media/all_your_snippets_at_your_fingertips.a5f67be0.svg";